// extracted by mini-css-extract-plugin
module.exports = {"ratings":"Ratings_ratings__1r_L9","scaleXin":"Ratings_scaleXin__2AURS","fadeIn":"Ratings_fadeIn__2Egb3"};